module.exports = __webpack_public_path__ + "img/rwandamap.a2a4735c.png";